module.exports = __webpack_public_path__ + "img/confirmation.a4f06f74.svg";